import { useContext, useEffect, useState } from 'react';
import { PageTitleContext } from 'context/PageTitleContext';
import MusicCard from 'components/Music/card';
import { Backend } from 'api/ApiConsumer';
import { API_ROUTES } from 'routes/api';
import Loader from 'components/Loader';
import { CrumbsContext } from 'context/CrumbsContext';
import { StatsBar } from 'components/Charts/stats-bar';
import { ChartTable } from 'components/Dashboard/chart-table';
import { ColumnChart } from 'components/Charts/column-chart';
import { ChannelRecognitionTable } from 'components/Charts/channelRecognitionTable';
import { RecognitionByChannelTable } from 'components/Charts/recognitionByChannelTable';
import { normaliseTop5ArtistData, normaliseTop5LabelData } from 'api/util';
import { RecognitionSelector } from 'components/Charts/recognitionSelector';

export default function Dashboard() {
  const [top, setTop] = useState([]);
  const [loading, setLoading] = useState(true);
  let { setTitle } = useContext(PageTitleContext);
  let { setCrumbs } = useContext(CrumbsContext);

  const [showTop5Artists, setShowTop5Artists] = useState(true);
  const [showTop5Labels, setShowTop5Labels] = useState(true);

  useEffect(() => {
    setTitle('Dashboard');
    setCrumbs([]);
  }, []);

  useEffect(() => {
    setLoading(true);
    Backend.get(API_ROUTES.BROADCAST.TOP_TITLES(5))
      .then((res) => setTop(res?.data))
      .catch((err) => console.error('new top api error', err))
      .finally(() => setLoading(false));
  }, []);

  const renderTop5MTD = () => {
    if (!showTop5Artists && !showTop5Labels) return <></>;

    return (
      <section className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-5">
        {showTop5Artists ? (
          <div className="sm:col-span-1">
            <h3 className="mb-2 font-medium profile-overview-title">
              Top 5 Artists (MTD)
            </h3>
            <ColumnChart
              url={API_ROUTES.BROADCAST.TOP_ARTISTS()}
              onDataLoad={(hasDataToShow) => setShowTop5Artists(hasDataToShow)}
              normaliseData={normaliseTop5ArtistData}
              options={{
                legend: { position: 'none' },
              }}
            />
          </div>
        ) : (
          <></>
        )}
        {showTop5Labels ? (
          <div className="sm:col-span-1">
            <h3 className="mb-2 font-medium profile-overview-title">
              Top 5 Labels (MTD)
            </h3>
            <ColumnChart
              url={API_ROUTES.BROADCAST.TOP_LABELS()}
              onDataLoad={(hasDataToShow) => setShowTop5Labels(hasDataToShow)}
              normaliseData={normaliseTop5LabelData}
              options={{
                legend: { position: 'none' },
              }}
            />
          </div>
        ) : (
          <></>
        )}
      </section>
    );
  };

  return (
    <>
      <div className="min-h-full px-5 py-5 mt-0 mb-5">
        {/*<DashboardFilter details={details} setDetails={setDetails}/>*/}
        {!loading ? (
          <h3 className="mb-1 font-medium profile-overview-title">
            This Months Top 5 Tracks
          </h3>
        ) : null}
        {loading ? (
          <Loader upload_message={'loading'} full_height={true} />
        ) : (
          <section className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 mt-3">
            {top.map((track, index) => {
              return (
                <MusicCard
                  showRanking
                  key={track.acrid}
                  music={track}
                  number={index + 1}
                  can_play={false}
                />
              );
            })}
          </section>
        )}
        <section className="grid grid-cols-1 sm:grid-cols-4 gap-4 mt-5">
          <div className="sm:col-span-4">
            <h3 className="mb-2 font-medium profile-overview-title">
              General Statistics
            </h3>
            <StatsBar />
          </div>
        </section>

        <RecognitionSelector />

        <ChannelRecognitionTable
          url={API_ROUTES.BROADCAST.REPORTS.COMPARISON.STATION}
          normaliseData={(data) => {
            return data.map((item) => {
              const total = item.recognised + item.unrecognised;
              item.performance = (item.recognised / total) * 100;
              return item;
            });
          }}
        />

        {renderTop5MTD()}

        <section className="grid grid-cols-1 xl:grid-cols-1 2xl:grid-cols-2 gap-4 mt-5">
          <div className="col-span-2">
            <h3 className="mb-2 font-medium profile-overview-title">
              Top 5 Tracks on TV (MTD)
            </h3>
            <ChartTable
              useNewAPI
              url={API_ROUTES.BROADCAST.TV_TOP_TRACKS()}
              title={'right'}
            />
          </div>
          <div className="col-span-2">
            <h3 className="mb-2 font-medium profile-overview-title">
              Top 5 Tracks on Radio (MTD)
            </h3>
            <ChartTable
              useNewAPI
              url={API_ROUTES.BROADCAST.RADIO_TOP_TRACKS()}
              title={'left'}
            />
          </div>
        </section>

        <RecognitionByChannelTable
          url={API_ROUTES.BROADCAST.REPORTS.COMPARISON.STATION_MONTHLY}
          normaliseData={(data) => {
            const indexes = {};

            let i = 0;
            const ret = [];

            data.forEach((item) => {
              if (!item.broadcast_stream__name) return;

              if (!Number.isInteger(indexes[item.broadcast_stream__name])) {
                indexes[item.broadcast_stream__name] = i;
                ret[i] = Array(13)
                  .fill(item.broadcast_stream__name)
                  .map((channelName) => ({
                    channel: channelName,
                    recognised: 0,
                    unrecognised: 0,
                    performance: '0 %',
                  }));
                i++;
              }
              const j = indexes[item.broadcast_stream__name];
              const total = item.recognised + item.unrecognised;
              ret[j][item.month] = {
                ...ret[j][item.month],
                month: item.month,
                ...item,
                performance:
                  ((item.recognised / total) * 100).toFixed(2) + ' %',
              };
            });

            return ret;
          }}
        />
      </div>
    </>
  );
}
